$(document).ready(function(){
    function activateItem(element) {
        $('.list-item').removeClass('active');
        $('.content-item').removeClass('active');

        element.addClass('active');
        var target = element.data('target');
        $('#' + target).addClass('active');
    }

    // Handle click events on list items within the dropdown
    $('.location-cards .list-item').click(function(e){
        e.preventDefault(); // Prevent default anchor behavior
        activateItem($(this));

        // Update the dropdown button text with the selected location
        $('#locationDropdown').text($(this).text());
    });

    // Handle Enter key press for accessibility
    $('.location-cards .list-item').keydown(function(e){
        if (e.key === 'Enter' || e.keyCode === 13) {
            activateItem($(this));

            // Update the dropdown button text with the selected location
            $('#locationDropdown').text($(this).text());
        }
    });
});
